import { Link } from 'react-router-dom'

export default function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-crg-deep text-white pt-8 pb-4 border-t border-white/5">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Columna 1: Branding */}
          <div className="flex flex-col space-y-3">
            <img 
              src="/logo.png" 
              alt="Construredgas SAS" 
              className="h-20 w-auto brightness-0 invert self-start" 
              loading="lazy"
            />
            <p className="text-blue-100/70 text-xs leading-relaxed text-justify max-w-[280px]">
              Ingeniería especializada en diseño, construcción y mantenimiento de redes de gas natural y propano. 
              Comprometidos con la seguridad y la calidad en Ibagué y el Tolima.
            </p>
          </div>

          {/* Columna 2: Enlaces Rápidos */}
          <div>
            <h4 className="text-base font-heading font-semibold mb-4 border-b border-crg-light/30 pb-1 inline-block">
              Navegación
            </h4>
            <ul className="space-y-2 text-sm text-blue-100/80">
              <li><Link to="/" className="hover:text-crg-light transition-colors">Inicio</Link></li>
              <li><Link to="/servicios" className="hover:text-crg-light transition-colors">Servicios</Link></li>
              <li><Link to="/nosotros" className="hover:text-crg-light transition-colors">Quiénes somos</Link></li>
              <li><Link to="/contacto" className="hover:text-crg-light transition-colors">Contacto</Link></li>
              <li><Link to="/tienda" className="hover:text-crg-light transition-colors">Tienda</Link></li>
            </ul>
          </div>

          {/* Columna 3: Contacto Directo */}
          <div className="space-y-3">
            <h4 className="text-base font-heading font-semibold mb-1 border-b border-crg-light/30 pb-1 inline-block">
              Contacto
            </h4>
            <div className="space-y-2 text-sm text-blue-100/80">
              <p className="flex items-start gap-3">
                <svg className="w-5 h-5 text-crg-light mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
                <span>Carrera 9 No. 117-57 Manzana 1 Casa 2<br />Barrio Cantabria etapa 5, Ibagué – Tolima</span>
              </p>
              <div className="flex items-start gap-3">
                <svg className="w-5 h-5 text-crg-light mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" /></svg>
                <div className="flex flex-col">
                  <a href="tel:+573134017798" className="hover:text-white transition-colors">313 401 7798</a>
                  <a href="tel:+573003413263" className="hover:text-white transition-colors">300 341 3263</a>
                </div>
              </div>
              <p className="flex items-center gap-3">
                <svg className="w-5 h-5 text-crg-light" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>
                <a href="mailto:gerencia@construredgas.co" className="hover:text-white transition-colors">gerencia@construredgas.co</a>
              </p>
            </div>
          </div>
        </div>

        {/* Barra inferior: NIT y Copyright */}
        <div className="pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-center md:text-left">
            <p className="text-xs text-blue-300 uppercase tracking-widest font-medium">NIT: 900.510.731-9</p>
            <p className="text-[9px] text-blue-100/40 mt-0.5">© {currentYear} Construredgas S.A.S. Todos los derechos reservados.</p>
          </div>
          <div className="flex gap-4">
            {/* Placeholders para redes sociales */}
            <a href="#" className="p-2 bg-white/5 rounded-full hover:bg-crg-light transition-colors" aria-label="Facebook">
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"/></svg>
            </a>
            <a href="#" className="p-2 bg-white/5 rounded-full hover:bg-crg-light transition-colors" aria-label="Instagram">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}